import styled from '@emotion/styled';
import { theme } from '../../../../theme';
export const NavigationPanel = styled.nav `
	overflow: auto;
	display: flex;
	flex-direction: column;
	height: 100%;
	background: none;
	padding: ${theme.spacing.space30} 0 ${theme.spacing.space30} ${theme.spacing.space30};

	ul {
		margin: 0;
		padding: 0;

		/*
		This pushes the subnavigation to the bottom of the nav panel.
		Reliant on the parent having "flex-direction: column".
		*/
		&.navigation {
			flex-grow: 1;
		}
	}

	li {
		list-style: none;
	}

	.logo {
		display: inline-block;
		margin: ${theme.spacing.space50} 0 ${theme.spacing.space50} 15px;

		img {
			display: block;
			margin-right: ${theme.spacing.space20}
			height: ${theme.spacing.space50};
			max-width: 100%;
			height: 18px;
		}
	}
`;
//# sourceMappingURL=NavigationPanel.styled.js.map